module.exports = __webpack_public_path__ + "img/12.2c5f81ab.jpg";